import { Actions, ClientModules } from '../enum';
import { IColorOption, IPermissionNode } from '../interfaces';
import { SuccessDialogData } from '../../../../shared/interfaces';

export const desktopPermissions: IPermissionNode[] = [
  {
    resource: ClientModules.FORM_BUILDER,
    name: 'Form Builder',
    actions: [Actions.READ],
    description: 'Access and view the form templates list.',
    selected: true,
    children: [
      {
        name: 'Create and edit forms',
        actions: [Actions.CREATE, Actions.EDIT, Actions.ASSIGN],
        selected: true,
        resource: ClientModules.FORM_BUILDER,

        description:
          'Create new Forms, edit existing ones and assign forms to Roles.',
      },
      {
        name: 'Delete forms',
        actions: [Actions.DELETE],
        selected: true,
        resource: ClientModules.FORM_BUILDER,
        description: 'Delete form templates created in the Forms tab.',
      },
    ],
  },
  {
    resource: ClientModules.USERS_MANAGEMENT,
    name: 'User Management',
    actions: [Actions.READ],
    description: 'Access to Users page.',
    selected: true,
    children: [
      {
        name: 'Create users',
        actions: [Actions.CREATE, Actions.EDIT],
        description: 'Create new Users and assign roles.',
        selected: true,
        resource: ClientModules.USERS_MANAGEMENT,
      },
      {
        name: 'Delete Users',
        actions: [Actions.DELETE],
        description: 'Delete any user from the Users page.',
        selected: true,
        resource: ClientModules.USERS_MANAGEMENT,
      },
      {
        name: 'Change roles',
        actions: [Actions.CHANGE],
        description: 'Change roles of Users.',
        selected: true,
        resource: ClientModules.USERS_MANAGEMENT,
      },
    ],
  },
  {
    resource: ClientModules.ROLES_MANAGEMENT,
    name: 'Roles Management',
    actions: [Actions.READ],
    description: 'Access to Roles page.',
    selected: true,
    children: [
      {
        name: 'Create and Edit Roles',
        actions: [Actions.CREATE, Actions.EDIT],
        description:
          'Create new Roles and edit existing ones. In each Role you will be able to define its permissions and assign the Role to users.',
        selected: true,
        resource: ClientModules.ROLES_MANAGEMENT,
      },
      {
        name: 'Delete Roles',
        actions: [Actions.DELETE],
        description:
          'Delete an empty Role. The Role can only be deleted once all assigned members have been removed.',
        selected: true,
        resource: ClientModules.ROLES_MANAGEMENT,
      },
    ],
  },
  {
    resource: ClientModules.REPORTS,
    name: 'Reports',
    actions: [Actions.READ],
    description: 'Access to Reports page.',
    selected: true,
  },
];

export const mobilePermissions: IPermissionNode[] = [
  {
    resource: ClientModules.FORMS_LIST,
    name: 'Forms',
    actions: [Actions.READ, Actions.EDIT, Actions.CREATE],
    description:
      'View and Fill forms in the mobile app. If this permission is disabled the Role will not have access to the mobile app.',
    selected: false,
    single: true,
  },
];

export const DESKTOP_PLATFORM = 'desktop_windows';
export const MOBILE_PLATFORM = 'smartphone';
export const DEFAULT_PLATFORM = 'devices';

export const ALL_USERS = 'all';
export const ASSIGNED_USERS = 'assigned';
export const NOT_ASSIGNED_USERS = 'notAssigned';

export const deleteRoleDialogData = {
  title: 'deleteRoleDialogTitle',
  content: 'deleteRoleDialogContent',
  cancelLabel: 'cancel',
  confirmLabel: 'confirm',
};

export const deleteRoleErrorDialogData = {
  icon: 'error_outline',
  title: 'unableDeleteRoleTitle',
  message: 'unableDeleteRoleMessage',
  action: 'cancel',
};

export const roleNameExistsErrorDialogData = {
  icon: 'error_outline',
  title: 'roleNameInUseTitle',
  message: 'roleNameInUseMessage',
  action: 'ok',
};

export const permissionsChangedDialogData = {
  icon: 'error_outline',
  title: 'roleEmptyTitle',
  message: 'roleEmptyMessage',
  action: 'ok',
};

export const ColorOptions: IColorOption[] = [
  {
    color: 'var(--mat-sys-extra-accent-on-orange)',
    background: 'var(--mat-sys-extra-accent-orange)',
  },
  {
    color: 'var(--mat-sys-extra-accent-on-red)',
    background: 'var(--mat-sys-extra-accent-red)',
  },
  {
    color: 'var(--mat-sys-extra-accent-on-purple)',
    background: 'var(--mat-sys-extra-accent-purple)',
  },
  {
    color: 'var(--mat-sys-extra-accent-on-blue)',
    background: 'var(--mat-sys-extra-accent-blue)',
  },
  {
    color: 'var(--mat-sys-extra-accent-on-green)',
    background: 'var(--mat-sys-extra-accent-green)',
  },
];

export const SNACKBAR_CREATE_MESSAGE = 'roleCreated';
export const SNACKBAR_UPDATE_MESSAGE = 'roleUpdated';
export const SNACKBAR_DELETE_MESSAGE = 'roleDeleted';

// Helper functions for success dialogs with translations
export function getRoleCreatedSuccessDialog(): SuccessDialogData {
  return {
    icon: 'check_circle',
    title: 'roleCreatedTitle',
    message: 'roleCreatedMessage',
    action: 'ok',
  };
}

export function getRoleDeletedSuccessDialog(roleName: string): SuccessDialogData {
  return {
    icon: 'check_circle',
    title: 'roleDeletedTitle',
    message: `${roleName} roleDeletedMessage`,
    messageParams: { roleName },
    action: 'ok',
  };
}

export function getRoleUpdatedSuccessDialog(roleName: string): SuccessDialogData {
  return {
    icon: 'check_circle',
    title: 'roleUpdatedTitle',
    message: `${roleName} 'roleUpdatedMessage'`,
    messageParams: { roleName },
    action: 'ok',
  };
}
